module.exports = __webpack_public_path__ + "assets/be.786a9ae2.svg";